/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GrowRegistrationStatus {
  NONE = 'none',
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}
